module.exports = __webpack_public_path__ + "static/media/planta1.fff77290.png";